const data = {
  zh: {
    title: '萤石物联网啊卡',
    content: [
      '<h4>支持购买服务的国家：英国、法国、德国、意大利、西班牙。</h4>',
      '<h4>支持使用服务的国家：奥地利、比利时、保加利亚、克罗地亚、塞浦路斯、捷克共和国、丹麦、爱沙尼亚、芬兰、法国、德国、希腊、匈牙利、爱尔兰、意大利、拉脱维亚、立陶宛、卢森堡、马耳他、荷兰、波兰、葡萄牙、罗马尼亚、斯洛伐克、斯洛文尼亚、西班牙、瑞典、英国。</h4'
    ]
  },
  eu: {
    title: 'Supported Country Description',
    content: [
      '<h4>Countries that support purchasing services: the United Kingdom, France, Germany, Italy, Spain.</h4>',
      '<h4>Countries that support using services: Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain, Sweden, United Kingdom.</h4'
    ]
  }
}
export default data
